import { seoMeta } from "@/lib/ui/seo";
import { listManagedAccounts } from "./managed-accounts";

export const loginsRouteOptions = {
    ssr: false as const,
    loader: async () => await listManagedAccounts(),
    head: () => ({
        ...seoMeta({
            title: "Logins — Wags",
            description: "Review the logins Kits keeps for you.",
            url: "/settings/logins",
        }),
    }),
};
